/*
 * Ajax filtering for resources
 */

// eslint-disable-next-line no-unused-vars
import styles from '../../../sass/layouts/page_templates/template-news-press.scss';

// Encapsulate code within a jQuery ready function
(function($) {
    // Toggle the drop downs appearing
    const resourceSearch = '.rs-resource-search';
    $(resourceSearch).on('click', '.rs-resource-search__input-display__toggle', function() {
        $(this).parent().toggleClass('active');
        $(this).siblings().slideToggle(300);
    });

    // On select change, update the actual select, and the visible one too
    const dispSelect = '.rs-resource-search__select-display';
    const funcSelect = '.rs-resource-search__select-functional';
    $(resourceSearch).on('click', dispSelect + ' li', function() {
        const valSelect = $(this).data('topic');
        $(this).closest(dispSelect).siblings(funcSelect).val(valSelect).trigger('change');
        $(this).closest(dispSelect).removeClass('active');
        const displayText = $(this).text();
        $(this).closest(dispSelect).find('.rs-resource-search__input-display__toggle').text(displayText);
    });

    // Handle functional select change event
    $('.rs-resource-search__select-functional').on('change', function() {
        const selectedTopic = $(this).val();
        const currentUrl = window.location.href;
        const updatedUrl = updateQueryStringParameter(currentUrl, 'topic', selectedTopic);
        window.location.href = updatedUrl;
    });

    // Function to update query string parameter in URL
    function updateQueryStringParameter(uri, key, value) {
        const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        const separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + '=' + value + '$2');
        } else {
            return uri + separator + key + '=' + value;
        }
    }

    // Load more functionality
    $('.j-loadmore').on('click', '.j-loadmore--button', function(e) {
        // Setup _this variable and prevent default behaviour
        const _this = $(this);
        e.preventDefault();

        // Exit if in progress class is added
        if (_this.hasClass('in-progress')) return;

        // Add in progress class to prevent multiple clicks
        _this.addClass('in-progress');

        // Get the container element
        const container = _this.parents('.j-loadmore');

        // Get a list of classes for the object to use to find it in the results
        let containerClasses = '.' + container.attr('class');
        containerClasses = containerClasses.split(' ').join('.');

        // Get the page URL to fetch
        const url = $(this).attr('href');

        // Fetch the URL and replace/append the content
        window._fetch.callbackContent(url, function(result) {
            // Get results object
            const results = $(result);
            // Remove in progress class
            _this.removeClass('in-progress');
            // Add the posts from the results to the posts on the page
            container.find('.j-loadmore--posts').append(results.find(containerClasses).find('.j-loadmore--posts').html());
            // Replace the pagination on the page with the pagination on the fetched page
            container.find('.j-loadmore--pagination').html(results.find(containerClasses).find('.j-loadmore--pagination').html());
        });
    });
})(jQuery);
